import { Injectable } from '@angular/core';
import { Product } from '../../models/product/product';
import { AngularFireDatabase } from 'angularfire2/database';

// move this to a separate model (file)
class BizProduct extends Product {
  private imageUrl : string;
  private location : string;
  private subTitle : string;
  constructor(
    name,
    imageUrl,
    location,
    subTitle,
    description,
    price,
    id
  ){
    super("",
    0,
    [],
    "0 Working Days",
    "",
    "Category 6",
    "",
    "");
    this.imageUrl = imageUrl;
    this.location = location;
    this.subTitle = subTitle;
    super.setId(id);
    super.setName(name);
    super.setDescription(description);
    super.setPrice(price);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {

    private products : Product[]; // change the type here to Product
    private collectionName : string = '/products/'
    
    product1 = new BizProduct("Verdetty","https://picsum.photos/300/300?random=46","Randburg, Gauteng","Ladies Shoe Boutique","A reputable Upmarket Boutique type ladies shoe retailer with manufacturing agreements with Chinese factories, established brand, 2 retail shops in Worldwear Randburg and Kyalami serving the upmarket market with the following specs, for sale;Assets, Leases, staff, Italian brand, licences all included. Debtors and Creditors for sellers account.","1200000","fakeId56");
    
    product2 = new BizProduct("Recording Studio","https://picsum.photos/300/300?random=47","East Rand, Gauteng","Music Recording Studio","Recording studio for sale all equipment brand new, create the perfect atmosphere studio, Music Production, Recording, Mixing and Editing, Sound Design, Acoustical Design, and Consulting, doing demos, a business that empowers you to be an earning entrepreneur. Discover a unique business opportunity. This is a business opportunity to own and grow a dynamic business. Are you looking for a business opportunity that is highly profitable and offers great potential? A One-stop recording and publishing studio, inspire creativity, Produce professional-quality recording, and audiovisual products that are amazing. Specs as follows; 3.	Relocatable or take over existing lease","149000","fakeId57");
    
    product3 = new BizProduct("Digital Screen Marketing","https://picsum.photos/300/300?random=48","Undisclosed","Digital Screen Marketing","Business Advertising Digital Medium Company for sale. create a marketing TV channel for your clients , Media marketing, social media marketing, Every business needs this product and service FIRST. This business is like something you've never seen before! It's amazing! You must see it to believe it! Now is your chance to own this niche business you’ve always dreamed in the Advertising segment of the world of business. This is the amazing opportunity in the fastest growing Advertising industry in the world today. Invest your personal drive, hard work, and creativity in your own business today. Yes this is the business for you and it always was. Are you looking for a business opportunity that is highly profitable and offers great potential? Discover a unique business opportunity .A business that empowers you to be an earning entrepreneur. All equipment brand new with full training. No experience needed. PASSIVE INCOME EVERY MONTH? Own a business that With the combined display of pictures, video, & live elements, digital advertising displays offer an excellent return on investment. Are you the entrepreneur who needs another income stream. Are you that someone who is tired of being sick and tired. Come witness a ground floor opportunity with all the risks eliminated. Easy to Set Up, no experience needed and complete training given .Fully and easily customization, Your 24/7 money machine To all your entrepreneurs, this will provide you with the critical advantage over your competition. If a picture is worth a thousand words, then digital is worth millions. NO EXPERIENCE NEEDED !!! There's much more.... If you are a entrepreneur business owner, working for a boss, doctor, realtor, author, aspiring performer, or network marketer, then you need to see our LIVE product overview. This is guaranteed to take whatever you do or want to do to the next level, instantaneously. Comes with a Complete client base summary below","140000","fakeId58");

    product4 = new BizProduct("5 Star Conference Venue Center, Day Spa and Beauty School","https://picsum.photos/300/300?random=49","East Rand, Gauteng","Conference Venue Center, Day Spa and Beauty School","Winning Best of the Best Interior Decor Award In 2011. This Five Star Graded Conference Center with nine function and meeting rooms, ranging in capacity from 10 delegates to providing space for between 300-500 guests. Catering for all types of events, from private wedding receptions to corporate launches, banquet ceremonies, year-end functions, annual seminars, fashion shows, graduation ceremonies, training sessions, meetings/conferences and special events. Adjacent to the conference center lies the luxurious Pyramid Day Spa, where mind, body and soul can completely relax and unwind and re-invest in itself. This amazing day spa is a credit to the founder who has established a beautiful high quality brand, in this world class location. Facilities include: 9 Treatment rooms, including, 2 Private luxurious executive couples suites with own private steam shower and Jet Description: bath.Three treatment rooms with private en-suite outdoor shower facility. Sauna, Rasul and Vertical Sun Bed. Private men’s and ladies steam shower along with Roman bath. Dining area with full bar facility. Along with The Pyramid, The Pyramid Beauty School is situated on the 2nd and 3rd floor of the venue. The school forms part of the initiative that is - Rejuvenation and Redeveloping of the inner city of Johannesburg. Key Features and Benefit’s:High margin business. Skin, Massage and Beauty Facilities.Established client base of locals and tourists.Amazing fully trained team of staff.Excellent social presence on Twitter, Facebook and Instagram. A Preferred supplier to provide massage and spa services. 1.	Sale Type; Lock Stock Barrel. 2.Location; Johannesburg South. 3.	Turnover Circa R25 million. 4.	Net Profit R4 million","29995000","fakeId59");

    product5 = new BizProduct("Bottle Store Springs, Day Spa and Beauty School","https://picsum.photos/300/300?random=50","East Rand, Gauteng","Bottle Store","spacious store's located in a residential centre, busy main road. TURN OVER : R400.000 MONTH. NETT: R60.000","1000000","fakeId60");

    product6 = new BizProduct("Successful Business & Premises","https://picsum.photos/300/300?random=51","East Rand, Gauteng","Successful Business & Premises","1183 m² standin very busy Cowen Ntuli Street. 485 m² workshop with 3 phase electricity and four large roller doors. Air conditioned office space with aluminium windows, tiled flooring and male/female bathrooms Excellent tyre repair and sales area and reception complete with worker change rooms and toilet facilities. Machinery included in the sale as well! This includes:","7150000","fakeId61");
    
    product7 = new BizProduct("Supermarket Germiston","https://picsum.photos/300/300?random=52","Germiston, Gauteng","Supermarket","A Stunning franchise store, 2000 sq. Meters store ,currently closed due to dispute","1000000","fakeId62");

    product8 = new BizProduct("Tavern Boksburg","https://picsum.photos/300/300?random=53","Boksburg, Gauteng","Tavern","Turn over bar 150.000. Turn over gambling 80.000. RENT: R13.000. ELECTRICITY: R3.000. DESCRIPTION: Tavern with gambling machines ,easy to run .NETT; 40.000","480000","fakeId63");

    product9 = new BizProduct("Internet Gambling Store","https://picsum.photos/300/300?random=54","?,Pretoria","Internet Gambling Store","TURN OVER: R150.000 monthly+- .NETT: 40.000 TO 60.000. DESCRIPTION: A medium store situated in PRETORIA RESIDENTIAL AREA. REASON FOR SALE: Owner Relocating. OPERATING HOURS: Monday to Saturday :07h00 to 19h00. Sunday :08h00 to 14h00","600000","fakeId64");

  constructor(private db : AngularFireDatabase) {

    // this should be moved in to a getProducts method and when that is called it updates the global prodict array
    this.products = [
      new Product(
        "Starter",
        1250.00,
        [
          "SARS Tax Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "",
        "Category 1",
        "https://picsum.photos/850/850?random=1",
        "fakeId1"
      ),
      new Product(
        "Express",
        1500.00,
        [
          "SARS Tax Registration",
          "BBBEE Certificate",
          "Share Certificate",
          "CSD Registration"
        ],
        "15 Minutes",
        "",
        "Category 1",
        "https://picsum.photos/850/850?random=2",
        "fakeId2"
      ),
      new Product(
        "Basic",
        1500.00,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=3",
        "fakeId3"
      ),
      new Product(
        "Standard",
        4500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=4",
        "fakeId4"
      ),
      new Product(
        "Enterprise",
        5500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration",
          "Workman Compensation"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=5",
        "fakeId5"
      ),
      new Product(
        "Premium",
        9500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration",
          "Workman Compensation",
          "CIDB"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=6",
        "fakeId6"
      ),new Product(
        "SARS Tax Registration",
        500,
        ["SARS Tax Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=43",
        "fakeId43"
      ),new Product(
        "Co-Operative Registration",
        1500,
        ["Co-Operative Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=44",
        "fakeId44"
      ),new Product(
        "NPO Registration",
        1500,
        ["NPO Registration"],
        "2-6 Working Days",
        "A Nonprofit Organisation (NPO) is an organisation that uses its surplus revenues to further achieve its purpose or ‘mission’, rather than distributing its surplus income to the Organisation’s Directors / Shareholders (or equivalents) as profit or dividends. We can assist with your Non Profit Organisation (NPO) Registration.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=45",
        "fakeId45"
      ),new Product(
        "UIF Registration",
        500,
        ["UIF Registration"],
        "2-6 Working Days",
        "We register quickly the business for UIF at the Department of Labour so that the business complies with its statutory obligations. It is mandatory that every business with 1 or more employess register for the Unemployment Insurance Fund(UIF) and deduct 1% of employee earnings",
        "Category 4 Individual-Services uif-reg",
        "https://picsum.photos/850/850?random=46",
        "fakeId46"
      ),new Product(
        "PAYE Registration",
        3000,
        ["PAYE Registration"],
        "2-6 Working Days",
        "Qualifying enterprises will be registered with the South African Revenue Services for PAYE. This registration comes with automatic UIF registration and SDL (optional Skills Development Levy) Registration. Once registered companies/entities will need to deduct Pay As You Earn from employees and pay to SARS.",
        "Category 4 Individual-Services paye",
        "https://picsum.photos/850/850?random=47",
        "fakeId47"
      ),new Product(
        "VAT Registration",
        3000,
        ["VAT Registration"],
        "2-6 Working Days",
        "VAT is levied at a standard rate of 15% on the supply of goods and services by registered vendors. Registration is compulsory for earnings above R1 million in a year but a business may also choose to register voluntarily for VAT if the value of taxable supplies made or to be made is less than R1 million, but has exceeded R50 000 in the past period of 12 months. When starting up various costs associated with new entities have Vat-able supplies which can be refunded by SARS on submission of qualifying tax invoices and many businesses need to register before getting into these expenses that’s where we come in.",
        "Category 4 Individual-Services vat",
        "https://picsum.photos/850/850?random=48",
        "fakeId48"
      ),new Product(
        "Import & Export Permit Registration",
        4500,
        ["Import & Export Permit Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services import-export-permit",
        "https://picsum.photos/850/850?random=49",
        "fakeId49"
      ),new Product(
        "COID Registration",
        4500,
        ["COID Registration"],
        "2-6 Working Days",
        "The aim of the COID Act is to provide for compensation in the case of disablement caused by occupational injuries and diseases, sustained or contracted by employees in the course of their employment, or death resulting from such injuries and diseases; and to provide for matters connected therewith. We register you for Workmens compensation with the Department of labour and get you a letter of good standing (LOGS)",
        "Category 4 Individual-Services coid",
        "https://picsum.photos/850/850?random=50",
        "fakeId50"
      ),new Product(
        "NCCA Registration",
        4500,
        ["NCCA Registration"],
        "2-6 Working Days",
        "The National Contract Cleaners Association (NCCA) is the regulatory body for Cleaning Companies. Although it is not mandatory to register with NCCA it is essential in the tender process. Thus, should you wish to start a Cleaning Company which will be applying for tenders in South Africa, it is mandatory that you are registered with the NCCA",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=51",
        "fakeId51"
      ),new Product(
        "CIDB GRADE 1 Registration",
        1450,
        ["CIDB GRADE 1 Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=52",
        "fakeId52"
      ),new Product(
        "CIDB GRADE Other Grades Registration",
        5000,
        ["CIDB GRADE Other Grades Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=53",
        "fakeId53"
      ),  
      new Product(
        "PSIRA Registration",
        15000,
        ["PSIRA Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=54",
        "fakeId54"
      ),
      new Product(
        "BBBE Certificate Registration",
        500,
        ["BBBE Certificate Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=55",
        "fakeId55"
      ),new Product(
        "Shelf Company 2020",
        1200,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020",
        "https://picsum.photos/850/850?random=7",
        "fakeId7"
      ),new Product(
        "Shelf Company 2020",
        5000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg paye",
        "https://picsum.photos/850/850?random=8",
        "fakeId8"
      ),new Product(
        "Shelf Company 2020",
        6000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye",
        "https://picsum.photos/850/850?random=9",
        "fakeId9"
      ),new Product(
        "Shelf Company 2020",
        10500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=10",
        "fakeId10"
      ),new Product(
        "Shelf Company 2020",
        12500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=11",
        "fakeId11"
      ),new Product(
        "Shelf Company 2020",
        12500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=12",
        "fakeId12"
      ),new Product(
        "Shelf Company 2019",
        2500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019",
        "https://picsum.photos/850/850?random=13",
        "fakeId13"
      ),new Product(
        "Shelf Company 2019",
        7500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg paye",
        "https://picsum.photos/850/850?random=14",
        "fakeId14"
      ),new Product(
        "Shelf Company 2019",
        10000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye",
        "https://picsum.photos/850/850?random=15",
        "fakeId15"
      ),new Product(
        "Shelf Company 2019",
        13500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=16",
        "fakeId16"
      ),new Product(
        "Shelf Company 2019",
        15500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=17",
        "fakeId17"
      ),new Product(
        "Shelf Company 2019",
        19500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=18",
        "fakeId18"
      ),new Product(
        "Shelf Company 2018",
        3000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018",
        "https://picsum.photos/850/850?random=19",
        "fakeId19"
      ),new Product(
        "Shelf Company 2018",
        6000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg paye",
        "https://picsum.photos/850/850?random=20",
        "fakeId20"
      ),new Product(
        "Shelf Company 2018",
        9000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye",
        "https://picsum.photos/850/850?random=21",
        "fakeId21"
      ),new Product(
        "Shelf Company 2018",
        13500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=22",
        "fakeId22"
      ),new Product(
        "Shelf Company 2018",
        16500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=23",
        "fakeId23"
      ),new Product(
        "Shelf Company 2018",
        17500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=24",
        "fakeId24"
      ),new Product(
        "Shelf Company 2017",
        3500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017",
        "https://picsum.photos/850/850?random=25",
        "fakeId25"
      ),new Product(
        "Shelf Company 2017 ",
        6500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg paye",
        "https://picsum.photos/850/850?random=26",
        "fakeId26"
      ),new Product(
        "Shelf Company 2017 ",
        9500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye",
        "https://picsum.photos/850/850?random=27",
        "fakeId27"
      ),new Product(
        "Shelf Company 2017 ",
        14500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=28",
        "fakeId28"
      ),new Product(
        "Shelf Company 2017 ",
        17500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=29",
        "fakeId29"
      ),new Product(
        "Shelf Company 2017 ",
        18500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=30",
        "fakeId30"
      ),new Product(
        "Shelf Company 2016",
        4500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016",
        "https://picsum.photos/850/850?random=31",
        "fakeId31"
      ),new Product(
        "Shelf Company 2016 ",
        7500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016  uif-reg paye",
        "https://picsum.photos/850/850?random=32",
        "fakeId32"
      ),new Product(
        "Shelf Company 2016 ",
        12000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye",
        "https://picsum.photos/850/850?random=33",
        "fakeId33"
      ),new Product(
        "Shelf Company 2016 ",
        17500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=34",
        "fakeId34"
      ),new Product(
        "Shelf Company 2016 ",
        19000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=35",
        "fakeId35"
      ),new Product(
        "Shelf Company 2016 ",
        22000,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016  uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=36",
        "fakeId36"
      ),new Product(
        "Shelf Company 2015",
        7000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015",
        "https://picsum.photos/850/850?random=37",
        "fakeId37"
      ),new Product(
        "Shelf Company 2015 ",
        10000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015  uif-reg paye",
        "https://picsum.photos/850/850?random=38",
        "fakeId38"
      ),new Product(
        "Shelf Company 2015 ",
        16000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye",
        "https://picsum.photos/850/850?random=39",
        "fakeId39"
      ),new Product(
        "Shelf Company 2015 ",
        19000,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=40",
        "fakeId40"
      ),new Product(
        "Shelf Company 2015 ",
        20000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015  uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=41",
        "fakeId41"
      ),new Product(
        "Shelf Company 2015 ",
        22500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=42",
        "fakeId42"
      ),
      this.product1,
      this.product2,
      this.product3,
      this.product4,
      this.product5,
      this.product6,
      this.product7,
      this.product8,
      this.product9,
    ];

  }
  
  // this method updates the database object with a product id
  // (HACKS: update vs set, getData())
  private updateID(product : Product) : boolean{
    this.db.object(this.collectionName+product.getId())
    // (OR-41.1, @sach) TODO: change this to an update method rather than a set (destructive)
    // this was hack to avoid the '0' that was appearing in the 
    // database structure
    .set(
      // (OR-41.2, @sach) TODO: this getData() call needs to be reworked so it
      //  doesnt need to happen like this
      product.getData()
    ).finally(
      // (@sach) TODO: this function must have a return value
    );

    return true // (@sach) TODO: this is in the wrong place
  }
  
  // this method adds a product to the firebase database
  // and returns the key for that product. this method
  // is done is a very HACKY way, try and tidy up
  // HACK (back and forth between db and service)
  // this method is made private so that additn to the database is done securely?
  private addProduct(product : Product) : string {
    let id = this.db.list(this.collectionName).push([product]).key;
    product.setId(id);
    this.updateID(product);
    return id;
  }

  // (@sach) TODO: this method should not be feeding the~
  // products to a seperate array, there should be only one
  // products array
  // TEST NOT YET WORKING
  // this must return a product array
  _getProducts(){
    return this.db.list(this.collectionName);
  }

  getProducts(_filter?) : Product[] {
    // (OR-20,@sach) TODO: implement this

    this.products = [
      new Product(
        "Starter",
        1250.00,
        [
          "SARS Tax Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "",
        "Category 1",
        "https://picsum.photos/850/850?random=1",
        "fakeId1"
      ),
      new Product(
        "Express",
        1500.00,
        [
          "SARS Tax Registration",
          "BBBEE Certificate",
          "Share Certificate",
          "CSD Registration"
        ],
        "15 Minutes",
        "",
        "Category 1",
        "https://picsum.photos/850/850?random=2",
        "fakeId2"
      ),
      new Product(
        "Basic",
        1500.00,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=3",
        "fakeId3"
      ),
      new Product(
        "Standard",
        4500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=4",
        "fakeId4"
      ),
      new Product(
        "Enterprise",
        5500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration",
          "Workman Compensation"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=5",
        "fakeId5"
      ),
      new Product(
        "Premium",
        9500.00,
        [
          "SARS Tax Registration",
          "Share Certificate",
          "Tax Clearance",
          "BBBEE Certificate",
          "CSD Registration",
          "PAYE & UIF Registration",
          "VAT Registration",
          "Workman Compensation",
          "CIDB"
        ],
        "2-6 Working Days",
        "",
        "Category 2",
        "https://picsum.photos/850/850?random=6",
        "fakeId6"
      ),new Product(
        "SARS Tax Registration",
        500,
        ["SARS Tax Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=43",
        "fakeId43"
      ),new Product(
        "Co-Operative Registration",
        1500,
        ["Co-Operative Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=44",
        "fakeId44"
      ),new Product(
        "NPO Registration",
        1500,
        ["NPO Registration"],
        "2-6 Working Days",
        "A Nonprofit Organisation (NPO) is an organisation that uses its surplus revenues to further achieve its purpose or ‘mission’, rather than distributing its surplus income to the Organisation’s Directors / Shareholders (or equivalents) as profit or dividends. We can assist with your Non Profit Organisation (NPO) Registration.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=45",
        "fakeId45"
      ),new Product(
        "UIF Registration",
        500,
        ["UIF Registration"],
        "2-6 Working Days",
        "We register quickly the business for UIF at the Department of Labour so that the business complies with its statutory obligations. It is mandatory that every business with 1 or more employess register for the Unemployment Insurance Fund(UIF) and deduct 1% of employee earnings",
        "Category 4 Individual-Services uif-reg",
        "https://picsum.photos/850/850?random=46",
        "fakeId46"
      ),new Product(
        "PAYE Registration",
        3000,
        ["PAYE Registration"],
        "2-6 Working Days",
        "Qualifying enterprises will be registered with the South African Revenue Services for PAYE. This registration comes with automatic UIF registration and SDL (optional Skills Development Levy) Registration. Once registered companies/entities will need to deduct Pay As You Earn from employees and pay to SARS.",
        "Category 4 Individual-Services paye",
        "https://picsum.photos/850/850?random=47",
        "fakeId47"
      ),new Product(
        "VAT Registration",
        3000,
        ["VAT Registration"],
        "2-6 Working Days",
        "VAT is levied at a standard rate of 15% on the supply of goods and services by registered vendors. Registration is compulsory for earnings above R1 million in a year but a business may also choose to register voluntarily for VAT if the value of taxable supplies made or to be made is less than R1 million, but has exceeded R50 000 in the past period of 12 months. When starting up various costs associated with new entities have Vat-able supplies which can be refunded by SARS on submission of qualifying tax invoices and many businesses need to register before getting into these expenses that’s where we come in.",
        "Category 4 Individual-Services vat",
        "https://picsum.photos/850/850?random=48",
        "fakeId48"
      ),new Product(
        "Import & Export Permit Registration",
        4500,
        ["Import & Export Permit Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services import-export-permit",
        "https://picsum.photos/850/850?random=49",
        "fakeId49"
      ),new Product(
        "COID Registration",
        4500,
        ["COID Registration"],
        "2-6 Working Days",
        "The aim of the COID Act is to provide for compensation in the case of disablement caused by occupational injuries and diseases, sustained or contracted by employees in the course of their employment, or death resulting from such injuries and diseases; and to provide for matters connected therewith. We register you for Workmens compensation with the Department of labour and get you a letter of good standing (LOGS)",
        "Category 4 Individual-Services coid",
        "https://picsum.photos/850/850?random=50",
        "fakeId50"
      ),new Product(
        "NCCA Registration",
        4500,
        ["NCCA Registration"],
        "2-6 Working Days",
        "The National Contract Cleaners Association (NCCA) is the regulatory body for Cleaning Companies. Although it is not mandatory to register with NCCA it is essential in the tender process. Thus, should you wish to start a Cleaning Company which will be applying for tenders in South Africa, it is mandatory that you are registered with the NCCA",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=51",
        "fakeId51"
      ),new Product(
        "CIDB GRADE 1 Registration",
        1450,
        ["CIDB GRADE 1 Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=52",
        "fakeId52"
      ),new Product(
        "CIDB GRADE Other Grades Registration",
        5000,
        ["CIDB GRADE Other Grades Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=53",
        "fakeId53"
      ),  
      new Product(
        "PSIRA Registration",
        15000,
        ["PSIRA Registration"],
        "2-6 Working Days",
        "The Construction Industry Development Board (CIDB) is a Government Organisation that ensures South African Companies in the Construction Industry keeps high standards. They require all Construction Companies who want to apply for Tenders / Big Contracts to register with them.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=54",
        "fakeId54"
      ),
      new Product(
        "BBBE Certificate Registration",
        500,
        ["BBBE Certificate Registration"],
        "2-6 Working Days",
        "Nullam nisl ex, molestie eleifend congue ac, molestie vitae diam. Nam sit amet fermentum lorem. Integer feugiat, lectus euismod pretium finibus.",
        "Category 4 Individual-Services",
        "https://picsum.photos/850/850?random=55",
        "fakeId55"
      ),new Product(
        "Shelf Company 2020",
        1200,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020",
        "https://picsum.photos/850/850?random=7",
        "fakeId7"
      ),new Product(
        "Shelf Company 2020",
        5000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg paye",
        "https://picsum.photos/850/850?random=8",
        "fakeId8"
      ),new Product(
        "Shelf Company 2020",
        6000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye",
        "https://picsum.photos/850/850?random=9",
        "fakeId9"
      ),new Product(
        "Shelf Company 2020",
        10500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=10",
        "fakeId10"
      ),new Product(
        "Shelf Company 2020",
        12500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=11",
        "fakeId11"
      ),new Product(
        "Shelf Company 2020",
        12500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2020 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=12",
        "fakeId12"
      ),new Product(
        "Shelf Company 2019",
        2500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019",
        "https://picsum.photos/850/850?random=13",
        "fakeId13"
      ),new Product(
        "Shelf Company 2019",
        7500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg paye",
        "https://picsum.photos/850/850?random=14",
        "fakeId14"
      ),new Product(
        "Shelf Company 2019",
        10000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye",
        "https://picsum.photos/850/850?random=15",
        "fakeId15"
      ),new Product(
        "Shelf Company 2019",
        13500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=16",
        "fakeId16"
      ),new Product(
        "Shelf Company 2019",
        15500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=17",
        "fakeId17"
      ),new Product(
        "Shelf Company 2019",
        19500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2019 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=18",
        "fakeId18"
      ),new Product(
        "Shelf Company 2018",
        3000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018",
        "https://picsum.photos/850/850?random=19",
        "fakeId19"
      ),new Product(
        "Shelf Company 2018",
        6000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg paye",
        "https://picsum.photos/850/850?random=20",
        "fakeId20"
      ),new Product(
        "Shelf Company 2018",
        9000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye",
        "https://picsum.photos/850/850?random=21",
        "fakeId21"
      ),new Product(
        "Shelf Company 2018",
        13500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=22",
        "fakeId22"
      ),new Product(
        "Shelf Company 2018",
        16500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=23",
        "fakeId23"
      ),new Product(
        "Shelf Company 2018",
        17500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2018 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=24",
        "fakeId24"
      ),new Product(
        "Shelf Company 2017",
        3500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017",
        "https://picsum.photos/850/850?random=25",
        "fakeId25"
      ),new Product(
        "Shelf Company 2017 ",
        6500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg paye",
        "https://picsum.photos/850/850?random=26",
        "fakeId26"
      ),new Product(
        "Shelf Company 2017 ",
        9500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye",
        "https://picsum.photos/850/850?random=27",
        "fakeId27"
      ),new Product(
        "Shelf Company 2017 ",
        14500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=28",
        "fakeId28"
      ),new Product(
        "Shelf Company 2017 ",
        17500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=29",
        "fakeId29"
      ),new Product(
        "Shelf Company 2017 ",
        18500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2017 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=30",
        "fakeId30"
      ),new Product(
        "Shelf Company 2016",
        4500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016",
        "https://picsum.photos/850/850?random=31",
        "fakeId31"
      ),new Product(
        "Shelf Company 2016 ",
        7500,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016  uif-reg paye",
        "https://picsum.photos/850/850?random=32",
        "fakeId32"
      ),new Product(
        "Shelf Company 2016 ",
        12000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye",
        "https://picsum.photos/850/850?random=33",
        "fakeId33"
      ),new Product(
        "Shelf Company 2016 ",
        17500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=34",
        "fakeId34"
      ),new Product(
        "Shelf Company 2016 ",
        19000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016 uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=35",
        "fakeId35"
      ),new Product(
        "Shelf Company 2016 ",
        22000,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2016  uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=36",
        "fakeId36"
      ),new Product(
        "Shelf Company 2015",
        7000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015",
        "https://picsum.photos/850/850?random=37",
        "fakeId37"
      ),new Product(
        "Shelf Company 2015 ",
        10000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015  uif-reg paye",
        "https://picsum.photos/850/850?random=38",
        "fakeId38"
      ),new Product(
        "Shelf Company 2015 ",
        16000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye",
        "https://picsum.photos/850/850?random=39",
        "fakeId39"
      ),new Product(
        "Shelf Company 2015 ",
        19000,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye coid bank-account",
        "https://picsum.photos/850/850?random=40",
        "fakeId40"
      ),new Product(
        "Shelf Company 2015 ",
        20000,
        [
          "SARS Tax Registration",
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "CIDB (Grade 1)",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015  uif-reg vat paye coid cidb bank-account",
        "https://picsum.photos/850/850?random=41",
        "fakeId41"
      ),new Product(
        "Shelf Company 2015 ",
        22500,
        [
          "Tax Clearance",
          "PAYE & UIF Registration",
          "VAT",
          "COID",
          "Import Export Permit",
          "Bank Account",
          "CSD Registration",
          "Share Certificate"
        ],
        "2-6 Working Days",
        "Get a preregistered, never traded company that has all the critical documents you may need to get going same day. We also change the business name to one of your choice at no extra cost.",
        "Category 3 2015 uif-reg vat paye coid import-export-permit bank-account",
        "https://picsum.photos/850/850?random=42",
        "fakeId42"
      ),
      this.product1,
      this.product2,
      this.product3,
      this.product4,
      this.product5,
      this.product6,
      this.product7,
      this.product8,
      this.product9,
    ];

    return this.products.filter(_filter);
  }

  // add the return type
  getProduct(id) : Product {
    return this.products.filter((product : Product) => product.getId() === id )[0];
  }

  // (OR-31, @sach) TODO: extract these filters to a product filters module
  isCategory1(product : Product, index, array) 
    {  
       return product.getCategory().includes("Category 1"); 
    }
  
  isCategory2(product : Product, index, array) 
  {  
      return product.getCategory().includes("Category 2"); 
  }

  isCategory3(product : Product, index, array) 
  {  
      return product.getCategory().includes("Category 3"); 
  }

  isCategory4(product : Product, index, array) 
  {  
      return product.getCategory().includes("Category 4"); 
  }

  isCategory5(product : Product, index, array) 
  {  
      return product.getCategory().includes("Category 5"); 
  }

  isCategory6(product : Product, index, array) 
  {  
      return product.getCategory().includes("Category 6"); 
  }
}

// the get product method should accept tags/categories just as strings not to have to construct a whole filter